import { useEffect, useRef } from 'react'

import { Button } from '@/components/ui/Button'
import { useSendPosUserTestEmail } from '@/hooks/use-email'
import { getApiErrorMessage } from '@/lib/api'

interface SendTestEmailButtonProps {
  email: string
  label?: string
}

export function SendTestEmailButton({
  email,
  label = 'Send test email',
}: SendTestEmailButtonProps) {
  const { mutate, isPending, isSuccess, isError, error, reset } = useSendPosUserTestEmail()
  const prevEmailRef = useRef(email)

  useEffect(() => {
    if (prevEmailRef.current !== email) {
      prevEmailRef.current = email
      reset()
    }
  }, [email, reset])

  return (
    <div className="flex items-center gap-3">
      <Button
        type="button"
        variant="secondary"
        size="sm"
        disabled={isPending || !email}
        onClick={() => {
          mutate(email)
        }}
      >
        {isPending ? 'Sending...' : label}
      </Button>
      {isSuccess && <span className="text-sm text-green-600 dark:text-green-400">Email sent.</span>}
      {isError && (
        <span className="text-sm text-red-600 dark:text-red-400">
          {getApiErrorMessage(error, 'Failed to send email')}
        </span>
      )}
    </div>
  )
}
